export const formatUnit = (balance) => {
  let newBalance = Math.round(balance);
  const hours = Math.floor(newBalance / 3600);
  const minutes = Math.floor((newBalance % 3600) / 60);
  const seconds = newBalance % 60;

  const parts = [];

  if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
  if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
  // if (seconds > 0) parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);

  // If everything is 0, return "0 seconds"
  if (parts.length === 0) return "0 seconds";

  return parts.join(" and ");
};
